import { useEffect, useState } from 'react';
import { getThirdPartyViewUrl } from 'common/api/wallet/cards';

export const useThirdPartyViewerUrl = ({
    cardId,
    shouldHideCardInfo,
}: {
    cardId: string | null;
    shouldHideCardInfo: boolean;
}) => {
    const [thirdPartyViewerUrl, setThirdPartyViewerUrl] = useState('');

    useEffect(() => {
        if (shouldHideCardInfo && cardId) {
            getThirdPartyViewUrl(cardId).then((r) => {
                if (r.data?.url) {
                    setThirdPartyViewerUrl(r.data?.url);
                }
            });
        } else {
            setThirdPartyViewerUrl('');
        }
    }, [cardId, shouldHideCardInfo]);

    return { thirdPartyViewerUrl };
};
